module.exports = __webpack_public_path__ + "static/media/gravure6.8935d504.jpg";